@if (show) {
	<div class="modal-overlay" (click)="onClose()">
	  <div class="modal-container" (click)="$event.stopPropagation()">
	    <div class="modal-header">
	      <h2 class="modal-title">{{ 'auth.resetPassword.title' | transloco }}</h2>
	      <button type="button" class="close-btn" (click)="onClose()">
	        <lucide-icon class="custom-icon" name="X"></lucide-icon>
	      </button>
	    </div>

	    <p class="modal-description">
	      {{ 'auth.resetPassword.description' | transloco }}
	    </p>

	    <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
	      <div class="form-field">
	        <app-input
	          [placeholder]="'auth.placeholders.email' | transloco"
	          [icon]="'envelope'"
	          [size]="'large'"
	          formControlName="email"
	          [error]="!!forgotForm.get('email')?.invalid && !!forgotForm.get('email')?.touched"
	          [errorMessage]="getErrorMessage('email')"
	        ></app-input>
	      </div>

	      <app-button
	        [label]="'auth.resetPassword.button' | transloco"
	        (click)="onSubmit()"
	        class="full-width-button"
	      ></app-button>
	    </form>

	    <app-button
	      [label]="'auth.verifyEmail.backToLogin' | transloco"
	      (onClick)="onClose()"
	      variant="link"
	      size="large"
	      class="bottom-link"
	    />
	  </div>
	</div>
}